export default {"src":"/_next/static/media/step2b.d89c14c1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};